
import { useEffect, useRef, useState } from 'react';
import './footer.css'




export const Footer =({active,darkMode}) =>{
  const [isFirstLoad,setISFirstLoad]=useState(true)
  const footerRef = useRef(null)
  
  const sections = {
    profile: "PROJECTS",
    project: "CONTACT",
    contact: (
      <div className=" text-center  font-extralight text-sm pb-12">
        Handcrafted by me © 2025.
        <br />
        Design prototype is available on{" "}
        <a
          className="text-gray-400"
          href="https://www.figma.com/design/cSHFnz3q0RyzsnlmiaYQK4/yichiba-Portfolio?node-id=0-1&p=f&t=PllGqvHEmGRncQ8y-0"
        >
          Figma
        </a>
      </div>
    ),
  };
  
  
  const [activeSection,setActiveSection]=useState(sections[active])
  
    useEffect(()=>{

      if(isFirstLoad){
        footerRef.current.classList.add("bottom-title-load");
        setTimeout(()=>{
          footerRef.current.classList.remove("bottom-title-load");
          setISFirstLoad(false)
        },1000)
        return
      }


        setTimeout(() => {
        setActiveSection(sections[active]);
      }, 600);
      footerRef.current.classList.remove("bottom-title");
      setTimeout(() => {
        footerRef.current.classList.add("bottom-title");
      }, 20);
      // eslint-disable-next-line
    },[active])




  return (
      <div ref={footerRef}  className={` hidden  fixed bottom-0 right-0 left-0 z-10  md:flex flex-col justify-center items-center `}>
        <div
          className={`text-xl font-serif   ${
            darkMode ? "text-white" : "text-black"
            
          }`}
        >
          {activeSection}
        </div>
        <div
          className={` w-[1px] h-6  ${darkMode ? "bg-white" : "bg-black"} ${
            active === "contact" ? "hidden" : "block"
          }`}
        ></div>
      </div>
    );
}
